// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;
  color: #1e293b;
}

.dashboard-wrapper {
  width: 100%;
}

.text-muted2 {
  color: #64748b;
}

.display-none {
  display: none;
}

.transition-opacity {
  opacity: 0;
  transition: opacity 0.8s ease;
}

.transition-opacity.opacity-100 {
  opacity: 1;
}

.focused-card {
  border: 2px solid #1f2937;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  z-index: 1;
}

.buttonArrow {
  z-index: 1;
}

.typing-dot {
  animation: blink 1s infinite;
}

.chat-page-layout {
  height: calc(100vh - 2rem);
  overflow: hidden;
}

.chat-sidebar-column,
.chat-main-column {
  height: 100%;
  min-height: 0;
}

.chat-sidebar-panel,
.chat-main-panel {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}

.chat-sidebar-scroll,
.chat-main-scroll {
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.chat-main-card {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  min-height: 0;
}

.chat-main-scroll {
  height: 100%;
}

@keyframes blink {
  0%,
  100% {
    opacity: 1;
  }

  50% {
    opacity: 0;
  }
}

@media (max-width: 1024px) {
  .login-bg {
    display: none !important;
  }

  .login-form-wrapper {
    flex: 1 1 !important;
    width: 100%;
  }
}

@media (min-width: 1024px) {
  .chat-page-layout {
    height: calc(100vh - 3rem);
  }
}

@media (max-width: 767.98px) {
  .chat-page-layout {
    height: auto;
    min-height: calc(100vh - 2rem);
    overflow: visible;
  }

  .chat-sidebar-column {
    height: 30vh;
  }

  .chat-main-column {
    height: 70vh;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,wFAAwF;EACxF,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;;IAEE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,oBAAkB;IAClB,WAAW;EACb;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,YAAY;IACZ,8BAA8B;IAC9B,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":["html,\nbody {\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  font-family: ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial;\n  color: #1e293b;\n}\n\n.dashboard-wrapper {\n  width: 100%;\n}\n\n.text-muted2 {\n  color: #64748b;\n}\n\n.display-none {\n  display: none;\n}\n\n.transition-opacity {\n  opacity: 0;\n  transition: opacity 0.8s ease;\n}\n\n.transition-opacity.opacity-100 {\n  opacity: 1;\n}\n\n.focused-card {\n  border: 2px solid #1f2937;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  z-index: 1;\n}\n\n.buttonArrow {\n  z-index: 1;\n}\n\n.typing-dot {\n  animation: blink 1s infinite;\n}\n\n.chat-page-layout {\n  height: calc(100vh - 2rem);\n  overflow: hidden;\n}\n\n.chat-sidebar-column,\n.chat-main-column {\n  height: 100%;\n  min-height: 0;\n}\n\n.chat-sidebar-panel,\n.chat-main-panel {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 0;\n}\n\n.chat-sidebar-scroll,\n.chat-main-scroll {\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n  overscroll-behavior: contain;\n}\n\n.chat-main-card {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  min-height: 0;\n}\n\n.chat-main-scroll {\n  height: 100%;\n}\n\n@keyframes blink {\n  0%,\n  100% {\n    opacity: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n}\n\n@media (max-width: 1024px) {\n  .login-bg {\n    display: none !important;\n  }\n\n  .login-form-wrapper {\n    flex: 1 !important;\n    width: 100%;\n  }\n}\n\n@media (min-width: 1024px) {\n  .chat-page-layout {\n    height: calc(100vh - 3rem);\n  }\n}\n\n@media (max-width: 767.98px) {\n  .chat-page-layout {\n    height: auto;\n    min-height: calc(100vh - 2rem);\n    overflow: visible;\n  }\n\n  .chat-sidebar-column {\n    height: 30vh;\n  }\n\n  .chat-main-column {\n    height: 70vh;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
